import { Pipe, PipeTransform } from '@angular/core';
import { SystemsIconsQuery } from 'src/app/systems/state/systems-icons.query';

@Pipe({
  standalone: true,
  name: 'systemIdToIcon'
})
export class SystemIdToIconPipe implements PipeTransform {

  constructor(
    private systemsIconsQuery: SystemsIconsQuery
  ) { }

  transform(systemId: string): string {
    return this.systemsIconsQuery.getIcon(systemId) ?? null;
  }
}

